// eslint-disable-next-line
export const getValuesFromComponents = (components) => {
  let address1 = '';
  let city = '';
  let state = '';
  let postalCode = '';
  let country = '';

  for (const component of components) {
    const componentType = component.types[0];

    switch (componentType) {
      case 'street_number': {
        address1 = `${component.long_name} ${address1}`;
        break;
      }

      case 'route': {
        address1 += component.short_name;
        break;
      }

      case 'locality':
        city = component.long_name;
        break;

      case 'administrative_area_level_1': {
        state = component.short_name;
        break;
      }

      case 'postal_code': {
        postalCode = component.long_name;
        break;
      }

      case 'country':
        country = component.short_name;
        break;

      default:
        break;
    }
  }

  return {
    address1,
    city,
    state,
    postalCode,
    country,
  };
};
